import { ViewUserResource } from '@/api/serverApi'
import EditTeamMemberForm from '@/components/forms/team-members/EditTeamMemberForm'
import { Modal, UserIcon } from '@cfs-fixings/shared'
import ConfirmEditUserUnsavedChangesModal from './ConfirmEditUserUnsavedChangesModal'
import { useState } from 'react'

type PropTypes = {
  isOpen: boolean,
  onClose: () => void,
  user?: ViewUserResource,
}

const EditTeamMemberModal = ({ isOpen, onClose, user }: PropTypes) => {
  const [isLoseChangesModalOpen, setIsLoseChangesModalOpen] = useState(false)
  const [userHasChanges, setUserHasChanges] = useState(false)

  return (
    <>
      {/* Form Modal */}
      <Modal
        isOpen={isOpen}
        title={
          <div className="flex items-center gap-2.5">
            <UserIcon className="w-[38px] h-[38px] bg-primary-500 p-[7px] shadow-md rounded-md" />
            Edit {user?.first_name ?? 'User'}
          </div>
        }
        onClose={() => {
          if (userHasChanges) {
            setIsLoseChangesModalOpen(true)
          } else {
            onClose?.()
          }
        }}
        size="md"
        content={
          user
            && (
              <EditTeamMemberForm
                userModel={user}
                onCancel={() => {
                  if (userHasChanges) {
                    setIsLoseChangesModalOpen(true)
                  } else {
                    onClose?.()
                  }
                }}
                onSuccess={() => {
                  onClose?.()
                }}
                onUserHasChanges={(hasChanges) => setUserHasChanges(hasChanges)}
              />
            )
        }
      />

      {/* Lose Changes Confirmation */}
      <ConfirmEditUserUnsavedChangesModal
        isOpen={isLoseChangesModalOpen}
        onClose={() => setIsLoseChangesModalOpen(false)}
        onConfirm={() => {
          setIsLoseChangesModalOpen(false)
          onClose?.()
        }}
      />
    </>
  )
}

export default EditTeamMemberModal
